import { variableNormalizer } from "@/utils/graphql";

export const getCourseOutlines = () => {
  return {
    name: "getCourseOutlines",
    ql: {
      query: `
      {
        getCourseOutlines {
          id
          degree{
            id
            code
            nameLocal
            nameEng
          }
          subjectGroup{
            id
            code
            nameLocal
            nameEng
          }
          subject{
            id
            code
            nameLocal
            nameEng
          }
          subjectCode
          teacher{
            id
            code
            firstNameLocal
            lastNameLocal
            firstNameEng
            lastNameEng
            availableTime
            telephone
            email
            picturePath
            socialMedia
            isSpecialTeacher
            isActive
            faculty{
              id
              code
              nameLocal
              nameEng
            }
            prefix{
              id
              nameLocal
              nameEng
              nameShortLocal
              nameShortEng
            }
            user{
              id
              code
              userLogin
              userGroup{
                id
                code
                nameLocal
                nameEng
              }
              email
            }
          }
          teacherCode
          totalPoint
          instruction
          streamIntroPath
          bookName1
          bookPic1
          bookDescription1
          bookName2
          bookPic2
          bookDescription2
          bookName3
          bookPic3
          bookDescription3
          
          courseOutlineUnits{
            id
            courseOutline{
              id
            }
            seq
            nameLocal
            nameEng
            descriptionLocal
            descriptionEng
            preTestExpectScore
            postTestExpectScore
            unitAgenda
            unitObjective
            unitReference
          }
          courseOutlineAssessments{
            id
            courseOutline{
              id
            }
            assessment{
              id
              nameLocal
              nameEng
            }
            seq
            percent
            score
          }
        }
      }`
    }
  }
};

export const getCourseOutlineById = (id) => {
  return {
    name: 'getCourseOutline',
    ql: {
      query: `
        {
          getCourseOutline(
            id: "${id}"
          )
          {
            id
            degree {
              id
              code
              nameLocal
              nameEng
            }
            subjectGroup {
              id
              code
              nameLocal
              nameEng
            }
            subject {
              id
              code
              nameLocal
              nameEng
              description
              creditDesc
              creditCalGrade
            }
            subjectCode
            teacher {
              id
              code
              firstNameLocal
              lastNameLocal
              firstNameEng
              lastNameEng
              availableTime
              telephone
              email
              picturePath
              socialMedia
              isSpecialTeacher
              isActive
              curriculum {
                id
                currId
                code
                nameLocal
                nameEng
              }
              faculty{
                id
                code
                nameLocal
                nameEng
              }
              prefix{
                id
                nameLocal
                nameEng
                nameShortLocal
                nameShortEng
              }
              user{
                id
                code
                userLogin
                userGroup{
                  id
                  code
                  nameLocal
                  nameEng
                }
                email
              }
            }
            teacherCode
            totalPoint
            instruction
            streamIntroPath
            bookName1
            bookPic1
            bookDescription1
            bookName2
            bookPic2
            bookDescription2
            bookName3
            bookPic3
            bookDescription3
            
            courseOutlineUnits{
              id
              courseOutline{
                id
              }
              seq
              nameLocal
              nameEng
              descriptionLocal
              descriptionEng
              preTestExpectScore
              postTestExpectScore
              unitAgenda
              unitObjective
              unitReference
            }
            courseOutlineAssessments{
              id
              courseOutline{
                id
              }
              assessment{
                id
                nameLocal
                nameEng
              }
              seq
              percent
              score
            }
          }
        }`
      }
    }
};

export const addCourseOutline = ({
  degreeId = null,
  subjectGroupId = null,
  subjectId = null,
  subjectCode = null,
  teacherId = null,
  teacherCode = null
}) => {
  return {
    name: "addCourseOutline",
    ql: {
      query: `
        mutation {
          addCourseOutline(
            degreeId: ${variableNormalizer(degreeId)}
            subjectGroupId: ${variableNormalizer(subjectGroupId)}
            subjectId: ${variableNormalizer(subjectId)}
            subjectCode: ${variableNormalizer(subjectCode)}
            teacherId: ${variableNormalizer(teacherId)}
            teacherCode: ${variableNormalizer(teacherCode)}
          ){
            id
            subjectCode
          }
        }
      `
    }
  }
};

export const addCourseOutlineAssessment = ({
  courseOutlineId = null,
  assessmentId = null,
  seq = null,
  percent = null,
  score = null
}) => {
  return {
    name: "addCourseOutlineAssessment",
    ql: {
      query: `
        mutation {
          addCourseOutlineAssessment(
            courseOutlineId: ${variableNormalizer(courseOutlineId)}
            assessmentId: ${variableNormalizer(assessmentId)}
            seq: ${variableNormalizer(seq)}
            percent: ${variableNormalizer(percent)}
            score: ${variableNormalizer(score)}
          ){
            id
          }
        }
      `
    }
  }
};

export const addCourseOutlineUnit = ({
  courseOutlineId = null,
  seq = null,
  nameLocal = null,
  nameEng = null,
  descriptionLocal = null,
  descriptionEng = null,
  preTestExpectScore = null,
  postTestExpectScore = null,
  unitAgenda = null,
  unitObjective = null,
  unitReference = null,
}) => {
  return {
    name: "addCourseOutlineUnit",
    ql: {
      query: `
        mutation {
          addCourseOutlineUnit(
            courseOutlineId: ${variableNormalizer(courseOutlineId)}
            courseOutlineUnitInput: {
              seq: ${variableNormalizer(seq)}
              nameLocal: ${variableNormalizer(nameLocal)}
              nameEng: ${variableNormalizer(nameEng)}
              descriptionLocal: ${variableNormalizer(descriptionLocal)}
              descriptionEng: ${variableNormalizer(descriptionEng)}
              preTestExpectScore: ${variableNormalizer(preTestExpectScore)}
              postTestExpectScore: ${variableNormalizer(postTestExpectScore)}
              unitAgenda: ${variableNormalizer(unitAgenda)}
              unitObjective: ${variableNormalizer(unitObjective)}
              unitReference: ${variableNormalizer(unitReference)}
            }
          )
          {
            id
          }
        }
      `
    }
  }
};

export const updateCourseOutline = ({
  id = null,
  totalPoint = null,
  instruction = null,
  streamIntroPath = null,
  bookName1 = null,
  bookPic1 = null,
  bookDescription1 = null,
  bookName2 = null,
  bookPic2 = null,
  bookDescription2 = null,
  bookName3 = null,
  bookPic3 = null,
  bookDescription3 = null
}) => {
  return {
    name: "updateCourseOutline",
    ql: {
      query: `
        mutation {
          updateCourseOutline(
            id: ${variableNormalizer(id)}
            courseOutlineInput: {
              totalPoint: ${variableNormalizer(totalPoint)}
              instruction: ${variableNormalizer(instruction)}
              streamIntroPath: ${variableNormalizer(streamIntroPath)}
              bookName1: ${variableNormalizer(bookName1)}
              bookPic1: ${variableNormalizer(bookPic1)}
              bookDescription1: ${variableNormalizer(bookDescription1)}
              bookName2: ${variableNormalizer(bookName2)}
              bookPic2: ${variableNormalizer(bookPic2)}
              bookDescription2: ${variableNormalizer(bookDescription2)}
              bookName3: ${variableNormalizer(bookName3)}
              bookPic3: ${variableNormalizer(bookPic3)}
              bookDescription3: ${variableNormalizer(bookDescription3)}
            }
          ){
            id
          }
        }
      `
    }
  }
};

export const updateCourseOutlineAssessment = ({
  id = null,
  assessmentId = null,
  seq = null,
  percent = null,
  score = null
}) => {
  return {
    name: "updateCourseOutlineAssessment",
    ql: {
      query: `
        mutation {
          updateCourseOutlineAssessment(
            id: ${variableNormalizer(id)}
            assessmentId: ${variableNormalizer(assessmentId)}
            seq: ${variableNormalizer(seq)}
            percent: ${variableNormalizer(percent)}
            score: ${variableNormalizer(score)}
          ){
            id
            assessment{
              nameLocal
              nameEng
            }
            seq
            percent
            score
          }
        }
      `
    }
  }
};

export const updateCourseOutlineUnit = ({
  id = null,
  seq = null,
  nameLocal = null,
  nameEng = null,
  descriptionLocal = null,
  descriptionEng = null,
  preTestExpectScore = null,
  postTestExpectScore = null,
  unitAgenda = null,
  unitObjective = null,
  unitReference = null,
}) => {
  return {
    name: "updateCourseOutlineUnit",
    ql: {
      query: `
        mutation {
          updateCourseOutlineUnit(
            id: ${variableNormalizer(id)}
            courseOutlineUnitInput: {
              seq: ${variableNormalizer(seq)}
              nameLocal: ${variableNormalizer(nameLocal)}
              nameEng: ${variableNormalizer(nameEng)}
              descriptionLocal: ${variableNormalizer(descriptionLocal)}
              descriptionEng: ${variableNormalizer(descriptionEng)}
              preTestExpectScore: ${variableNormalizer(preTestExpectScore)}
              postTestExpectScore: ${variableNormalizer(postTestExpectScore)}
              unitAgenda: ${variableNormalizer(unitAgenda)}
              unitObjective: ${variableNormalizer(unitObjective)}
              unitReference: ${variableNormalizer(unitReference)}
            }
          )
          {
            id
          }
        }
      `
    }
  }
};

export const deleteCourseOutlineAssessmentById = (id) => {
  return {
    name: "deleteCourseOutlineAssessmentById",
    ql: {
      query: `
        mutation {
          deleteCourseOutlineAssessment(
            id: ${variableNormalizer(id)}
          ){
            id
            courseOutline{
              id
            }
            assessment{
              id
              nameLocal
              nameEng
            }
            seq
            percent
            score
          }
        }
      `
    }
  }
};

export const deleteCourseOutlineUnitById = (id) => {
  return {
    name: "deleteCourseOutlineUnitById",
    ql: {
      query: `
        mutation {
          deleteCourseOutlineUnit(
            id: ${variableNormalizer(id)}
          ){
            id
          }
        }
      `
    }
  }
};

export const deleteCourseOutlineById = (id) => {
  return {
    name: "deleteCourseOutlineById",
    ql: {
      query: `
        mutation {
          deleteCourseOutline(
            id: "${id}"
          ){
            id
          }
        }
      `
    }
  }
};
